import { has } from 'lodash';
import { getLogger } from '@lib/logging';

const logger = getLogger('localStorage');

class LocalStorage {
  constructor() {
    if (!LocalStorage.instance) {
      this.localStore = null;
      if (typeof window !== 'undefined' && window.localStorage) {
        this.localStore = window.localStorage;
      }
      LocalStorage.instance = this;
    }
    return LocalStorage.instance;
  }

  parse(featureName) {
    if (this.localStore) {
      try {
        return JSON.parse(this.localStore.getItem(featureName)) || {};
      } catch (e) {
        logger.warn(e);
      }
    }
    return {};
  }

  add(featureName, key, value) {
    if (this.localStore) {
      const storageDict = this.parse(featureName);
      storageDict[key] = value;
      this.localStore.setItem(featureName, JSON.stringify(storageDict));
    }
  }

  get(featureName, key) {
    if (this.localStore) {
      const storageDict = this.parse(featureName);
      return has(storageDict, key) ? storageDict[key] : null;
    }
    return null;
  }

  removeByFeature(featureName) {
    if (this.localStore) {
      this.localStore.removeItem(featureName);
    }
  }

  removeByKey(featureName, key) {
    if (this.localStore) {
      const storageDict = this.parse(featureName);
      delete storageDict[key];
      this.localStore.setItem(featureName, JSON.stringify(storageDict));
    }
  }
}

// Expose as a singleton
const instance = new LocalStorage();
export default instance;
